module.exports = __webpack_public_path__ + "static/media/logo_mat_vertical.60815add.png";